export const ANONYMOUS_USER_ID_LOCAL_STORAGE_KEY = 'anonymous-user-id';
